// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3viy5","label":"Category_label__1cmqn","content":"Category_content__2_kCv","header":"Category_header__37oHu","location":"Category_location__3JhEU"};